import imgix from "@config/imgix"
import formatPrice from "@lib/formatPrice"
import React from "react"
import * as S from "./Slide.elements"

interface Props {
  id?: string
  name?: string
  price?: number
  isCurrent?: boolean
  onClick?: () => void
  style?: React.CSSProperties
}

const Slide: React.FC<Props> = ({
  id,
  name,
  price,
  isCurrent = false,
  onClick,
  style,
}) => {
  const src = imgix({
    key: `${id}`,
    type: "article",
    args: { w: 250, h: 250 },
  })

  return (
    <S.Item active={isCurrent} onClick={onClick}>
      <S.Img src={src} alt="" />
      <S.Details>
        {name}
        <span>{price && formatPrice(price)}</span>
      </S.Details>
    </S.Item>
  )
}

export default Slide
